module.exports = __webpack_public_path__ + "img/collection-weddingRingsSecretHeart@2x.cf431c7.jpg";